<script setup lang="ts">
withDefaults(defineProps<{
    headline?: string;
    subHead?: string;
}>(), {
    headline: '',
    subHead: '',
});

const ellipse87 = '/img/2026/gallery/ellipse-87.svg';
const ellipse88 = '/img/2026/gallery/ellipse-88.svg';
// 2x (original exports)
const g01_2x = '/img/2026/gallery/g01.png';
const g02_2x = '/img/2026/gallery/g02.png';
const g03_2x = '/img/2026/gallery/g03.png';
const g04_2x = '/img/2026/gallery/g04.png';
const g05_2x = '/img/2026/gallery/g05.png';
const g06_2x = '/img/2026/gallery/g06.png';
const g07_2x = '/img/2026/gallery/g07.png';
const g08_2x = '/img/2026/gallery/g08.png';
const g09_2x = '/img/2026/gallery/g09.png';
const g10_2x = '/img/2026/gallery/g10.png';
const g11_2x = '/img/2026/gallery/g11.png';
const g12_2x = '/img/2026/gallery/g12.png';
const g13_2x = '/img/2026/gallery/g13.png';
const g14_2x = '/img/2026/gallery/g14.png';
const g15_2x = '/img/2026/gallery/g15.png';
const g16_2x = '/img/2026/gallery/g16.png';
const g17_2x = '/img/2026/gallery/g17.png';
const g18_2x = '/img/2026/gallery/g18.png';
const g19_2x = '/img/2026/gallery/g19.png';
const g20_2x = '/img/2026/gallery/g20.png';
const g21_2x = '/img/2026/gallery/g21.png';
const g22_2x = '/img/2026/gallery/g22.png';
const g23_2x = '/img/2026/gallery/g23.png';
const g24_2x = '/img/2026/gallery/g24.png';
const g25_2x = '/img/2026/gallery/g25.png';
const g26_2x = '/img/2026/gallery/g26.png';
const g27_2x = '/img/2026/gallery/g27.png';
const g28_2x = '/img/2026/gallery/g28.png';
const g29_2x = '/img/2026/gallery/g29.png';
const g30_2x = '/img/2026/gallery/g30.png';
const g31_2x = '/img/2026/gallery/g31.png';
const g32_2x = '/img/2026/gallery/g32.png';
const g33_2x = '/img/2026/gallery/g33.png';
// 1x (half resolution)
const g01_1x = '/img/2026/gallery/1x/g01.png';
const g02_1x = '/img/2026/gallery/1x/g02.png';
const g03_1x = '/img/2026/gallery/1x/g03.png';
const g04_1x = '/img/2026/gallery/1x/g04.png';
const g05_1x = '/img/2026/gallery/1x/g05.png';
const g06_1x = '/img/2026/gallery/1x/g06.png';
const g07_1x = '/img/2026/gallery/1x/g07.png';
const g08_1x = '/img/2026/gallery/1x/g08.png';
const g09_1x = '/img/2026/gallery/1x/g09.png';
const g10_1x = '/img/2026/gallery/1x/g10.png';
const g11_1x = '/img/2026/gallery/1x/g11.png';
const g12_1x = '/img/2026/gallery/1x/g12.png';
const g13_1x = '/img/2026/gallery/1x/g13.png';
const g14_1x = '/img/2026/gallery/1x/g14.png';
const g15_1x = '/img/2026/gallery/1x/g15.png';
const g16_1x = '/img/2026/gallery/1x/g16.png';
const g17_1x = '/img/2026/gallery/1x/g17.png';
const g18_1x = '/img/2026/gallery/1x/g18.png';
const g19_1x = '/img/2026/gallery/1x/g19.png';
const g20_1x = '/img/2026/gallery/1x/g20.png';
const g21_1x = '/img/2026/gallery/1x/g21.png';
const g22_1x = '/img/2026/gallery/1x/g22.png';
const g23_1x = '/img/2026/gallery/1x/g23.png';
const g24_1x = '/img/2026/gallery/1x/g24.png';
const g25_1x = '/img/2026/gallery/1x/g25.png';
const g26_1x = '/img/2026/gallery/1x/g26.png';
const g27_1x = '/img/2026/gallery/1x/g27.png';
const g28_1x = '/img/2026/gallery/1x/g28.png';
const g29_1x = '/img/2026/gallery/1x/g29.png';
const g30_1x = '/img/2026/gallery/1x/g30.png';
const g31_1x = '/img/2026/gallery/1x/g31.png';
const g32_1x = '/img/2026/gallery/1x/g32.png';
const g33_1x = '/img/2026/gallery/1x/g33.png';

const sectionRef = ref(null);
const canvasRef = ref(null);
const scale = ref(1);

const hoveredPhoto = ref(-1);

// Drag-to-pan offset
const panOffset = reactive({ x: 0, y: 0 });
const isDragging = ref(false);
const dragStart = { x: 0, y: 0, ox: 0, oy: 0 };

const DESIGN_W = 1440;
const DESIGN_H = 751;
const OVERAGE = 1;

// Bounds based on actual photo edges (not decorative ellipses)
const CONTENT_LEFT = -131;
const CONTENT_RIGHT = 3748;
const CONTENT_TOP = -333;
const CONTENT_BOTTOM = 828;

const dragBounds = reactive({ minX: 0, maxX: 0, minY: 0, maxY: 0 });

function clamp(val, min, max) {
    return Math.min(max, Math.max(min, val));
}

function rubberBand(val, min, max) {
    if (val < min) return min - (min - val) * 0.3;
    if (val > max) return max + (val - max) * 0.3;
    return val;
}

function updateScale() {
    if (!sectionRef.value) return;
    const w = sectionRef.value.clientWidth;
    const h = sectionRef.value.clientHeight;
    const s = Math.min(1, Math.max(w / DESIGN_W, h / DESIGN_H) * OVERAGE);
    scale.value = s;

    const cx = DESIGN_W / 2;
    const cy = DESIGN_H / 2;
    dragBounds.minX = -Math.max(0, (CONTENT_RIGHT - cx) * s - w / 2);
    dragBounds.maxX = Math.max(0, (cx - CONTENT_LEFT) * s - w / 2);
    dragBounds.minY = -Math.max(0, (CONTENT_BOTTOM - cy) * s - h / 2);
    dragBounds.maxY = Math.max(0, (cy - CONTENT_TOP) * s - h / 2);

    // Clamp pan offset to new bounds so images reposition immediately on resize
    panOffset.x = clamp(panOffset.x, dragBounds.minX, dragBounds.maxX);
    panOffset.y = clamp(panOffset.y, dragBounds.minY, dragBounds.maxY);
}

// Velocity tracking for fling
const velocity = { x: 0, y: 0 };
let lastPointer = { x: 0, y: 0, t: 0 };
let flingRaf = null;

// Touch direction detection: 'pending' | 'pan' | 'scroll'
const gestureDir = ref('pending');
const GESTURE_THRESHOLD = 8; // px before we commit to a direction

function onPointerDown(e) {
    gestureDir.value = e.pointerType === 'touch' ? 'pending' : 'pan';
    isDragging.value = true;
    dragStart.x = e.clientX;
    dragStart.y = e.clientY;
    dragStart.ox = panOffset.x;
    dragStart.oy = panOffset.y;
    lastPointer.x = e.clientX;
    lastPointer.y = e.clientY;
    lastPointer.t = performance.now();
    velocity.x = 0;
    velocity.y = 0;
    if (flingRaf) cancelAnimationFrame(flingRaf);
    // Only capture immediately for mouse; touch waits for direction
    if (e.pointerType !== 'touch') {
        canvasRef.value?.setPointerCapture(e.pointerId);
    }
}

function onPointerMove(e) {
    if (!isDragging.value) return;

    // Detect gesture direction on touch
    if (gestureDir.value === 'pending') {
        const dx = Math.abs(e.clientX - dragStart.x);
        const dy = Math.abs(e.clientY - dragStart.y);
        if (dx < GESTURE_THRESHOLD && dy < GESTURE_THRESHOLD) return;
        if (dx >= dy) {
            gestureDir.value = 'pan';
            canvasRef.value?.setPointerCapture(e.pointerId);
        } else {
            gestureDir.value = 'scroll';
            isDragging.value = false;
            return;
        }
    }

    const now = performance.now();
    const dt = now - lastPointer.t;
    if (dt > 0) {
        velocity.x = (e.clientX - lastPointer.x) / dt;
        velocity.y = (e.clientY - lastPointer.y) / dt;
    }
    lastPointer.x = e.clientX;
    lastPointer.y = e.clientY;
    lastPointer.t = now;
    const rawX = dragStart.ox + (e.clientX - dragStart.x);
    const rawY = dragStart.oy + (e.clientY - dragStart.y);
    // Rubber-band: allow slight overshoot while dragging (dampened)
    panOffset.x = rubberBand(rawX, dragBounds.minX, dragBounds.maxX);
    panOffset.y = rubberBand(rawY, dragBounds.minY, dragBounds.maxY);
}

function onPointerUp() {
    isDragging.value = false;
    // Fling with elastic overshoot at boundaries
    const FRICTION = 0.95;
    const MIN_V = 0.05;
    const OVERSHOOT_MAX = 80; // max pixels past boundary
    const BOUNCE_STIFFNESS = 0.12; // spring force pulling back
    let vx = velocity.x * 16;
    let vy = velocity.y * 16;

    function step() {
        vx *= FRICTION;
        vy *= FRICTION;

        // Apply spring force when past bounds
        if (panOffset.x < dragBounds.minX) {
            vx += (dragBounds.minX - panOffset.x) * BOUNCE_STIFFNESS;
        } else if (panOffset.x > dragBounds.maxX) {
            vx += (dragBounds.maxX - panOffset.x) * BOUNCE_STIFFNESS;
        }
        if (panOffset.y < dragBounds.minY) {
            vy += (dragBounds.minY - panOffset.y) * BOUNCE_STIFFNESS;
        } else if (panOffset.y > dragBounds.maxY) {
            vy += (dragBounds.maxY - panOffset.y) * BOUNCE_STIFFNESS;
        }

        panOffset.x = clamp(panOffset.x + vx, dragBounds.minX - OVERSHOOT_MAX, dragBounds.maxX + OVERSHOOT_MAX);
        panOffset.y = clamp(panOffset.y + vy, dragBounds.minY - OVERSHOOT_MAX, dragBounds.maxY + OVERSHOOT_MAX);

        // Stop when velocity is low AND we're back in bounds
        const inBounds = panOffset.x >= dragBounds.minX && panOffset.x <= dragBounds.maxX
            && panOffset.y >= dragBounds.minY && panOffset.y <= dragBounds.maxY;
        if (Math.abs(vx) < MIN_V && Math.abs(vy) < MIN_V && inBounds) {
            panOffset.x = clamp(panOffset.x, dragBounds.minX, dragBounds.maxX);
            panOffset.y = clamp(panOffset.y, dragBounds.minY, dragBounds.maxY);
            return;
        }
        flingRaf = requestAnimationFrame(step);
    }
    flingRaf = requestAnimationFrame(step);
}

function onWheel(e) {
    // Only intercept horizontal-dominant gestures (Magic Mouse / trackpad horizontal swipe)
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    if (e.deltaX === 0) return;
    e.preventDefault();
    if (flingRaf) cancelAnimationFrame(flingRaf);
    panOffset.x = clamp(panOffset.x - e.deltaX, dragBounds.minX, dragBounds.maxX);
}

const isVisible = ref(false);
const prefersReducedMotion = ref(false);

onMounted(() => {
    updateScale();
    window.addEventListener('resize', updateScale);
    sectionRef.value?.addEventListener('wheel', onWheel, { passive: false });

    prefersReducedMotion.value = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion.value) {
        isVisible.value = true;
    } else {
        const isMobile = window.innerWidth < 768;
        const obs = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                isVisible.value = true;
                obs.disconnect();
            }
        }, { threshold: isMobile ? 0.2 : 0.75 });
        if (sectionRef.value) obs.observe(sectionRef.value);
    }
});

onUnmounted(() => {
    window.removeEventListener('resize', updateScale);
    sectionRef.value?.removeEventListener('wheel', onWheel);
    if (flingRaf) cancelAnimationFrame(flingRaf);
});

const canvasStyle = computed(() => ({
    width: DESIGN_W + 'px',
    height: DESIGN_H + 'px',
    transform: `translate(calc(-50% + ${panOffset.x}px), calc(-50% + ${panOffset.y}px)) scale(${scale.value})`,
    cursor: isDragging.value ? 'grabbing' : 'grab',
}));

const ellipses = [
    { src: ellipse87, x: 640, y: 587, w: 1004, h: 1004, expand: '-29.88%' },
    { src: ellipse88, x: -367, y: -411, w: 785, h: 785, expand: '-25.48%' },
];

const photos = [
    { src: g12_1x, src2x: g12_2x, alt: 'Two people with conference badges posing together in a colorful modern event space', x: -103, y: -146, w: 467, h: 463.5, inset: '0.15% 1.39% 0.77% 0', depth: 0.4 },
    { src: g06_1x, src2x: g06_2x, alt: 'Two women talking at a conference with exhibition booths in background', x: 306, y: -109, w: 259.5, h: 194, inset: '0.54% 0 0 4.44%', depth: 0.7 },
    { src: g04_1x, src2x: g04_2x, alt: 'Smiling woman with curly hair wearing conference badge and buttons gestures while sitting at table', x: 615, y: -267, w: 391, h: 541, inset: '2.4% 2.24% 2.58% 0', depth: 0.3 },
    { src: g07_1x, src2x: g07_2x, alt: 'Professional man in light shirt with conference lanyard, hand near chin in thoughtful pose', x: 997.5, y: -333, w: 544.5, h: 544, inset: '1.28% 1.73% 0.46% 0.67%', depth: 0.6 },
    { src: g02_1x, src2x: g02_2x, alt: 'Two businessmen in suits shaking hands and smiling at a conference', x: 268, y: 135, w: 297, h: 312.5, inset: '0 0 3.23% 3.14%', depth: 0.5 },
    { src: g11_1x, src2x: g11_2x, alt: 'Two smiling women with tattoos posing together at a conference event with pink lighting', x: 1335, y: 83.5, w: 295.5, h: 305, inset: '3.51% 1.81% 1.67% 4.03%', depth: 0.3 },
    { src: g05_1x, src2x: g05_2x, alt: 'Two women having a conversation on stage at a conference with colorful lighting', x: 699, y: 192, w: 525.5, h: 428, inset: '0.21% 1.66% 1.18% 1.08%', depth: 0.6 },
    { src: g03_1x, src2x: g03_2x, alt: 'Smiling man in suit speaking into microphone at conference with red stage lighting', x: 462, y: 284, w: 271.5, h: 318.5, inset: '7.28% 2.41% 1.02% 3.87%', depth: 0.4 },
    { src: g13_1x, src2x: g13_2x, alt: 'Professional woman in business attire smiling warmly at a conference', x: -131, y: 305.13, w: 320, h: 274.366, inset: '1.61% 4.14% 0 1.76%', depth: 0.7 },
    { src: g10_1x, src2x: g10_2x, alt: 'Man in black sweater sitting in white chair making hand gesture on stage with red and purple lighting', x: 1196, y: 355.5, w: 350, h: 410.5, inset: '1.21% 0.5% 0 0.86%', depth: 0.5 },
    { src: g01_1x, src2x: g01_2x, alt: 'Person in glasses and headband eating at table with hot sauce bottles and milk glass', x: 128, y: 376, w: 492, h: 491, depth: 0.3 },
    { src: g09_1x, src2x: g09_2x, alt: 'Woman in bright pink sweater laughing at conference event', x: 1089, y: 527, w: 284, h: 340, inset: '8.44% 5.71% 1.14% 0.84%', depth: 0.6 },
    { src: g08_1x, src2x: g08_2x, alt: 'Smiling woman with curly hair at a conference, wearing purple sweater with name badge', x: 640, y: 592, w: 431, h: 232, inset: '0.46% 1.84% 0 5.57%', depth: 0.4 },
    { src: g14_1x, src2x: g14_2x, alt: 'Smiling woman with blonde hair at a conference, looking engaged and attentive', x: -105, y: 628, w: 319, h: 200, inset: '0 5.82% 0 0', depth: 0.7 },
    { src: g17_1x, src2x: g17_2x, alt: 'Smiling bearded man in white shirt speaking at conference with orange gradient background', x: 1490, y: -85, w: 324, h: 224, inset: '1.33% 7.79% 3.2% 2.35%', depth: 0.5 },
    { src: g16_1x, src2x: g16_2x, alt: 'Smiling woman at conference registration desk wearing red shirt with lanyard', x: 1586, y: 53, w: 476, h: 403.5, inset: '2.08% 5.13% 5.09% 3.86%', depth: 0.4 },
    { src: g15_1x, src2x: g15_2x, alt: 'Woman in purple dress presenting on stage with hand extended at conference', x: 1568.5, y: 441, w: 298.5, h: 358.5, inset: '1.29% 1.65% 0.92% 0.6%', depth: 0.6 },
    { src: g18_1x, src2x: g18_2x, alt: 'Two people collaborating at a conference booth, man with beard and woman with cap smiling', x: 1802, y: 303.5, w: 274.5, h: 313.5, inset: '4.03% 0 6.02% 6.67%', depth: 0.3 },
    { src: g19_1x, src2x: g19_2x, alt: 'Two smiling women in graduation caps and gowns embracing at a ceremony', x: 1830, y: -191, w: 576.5, h: 520, inset: '0.57% 1.09% 2.43% 0.74%', depth: 0.5 },
    { src: g29_1x, src2x: g29_2x, alt: 'Two people in business attire having an animated conversation at a conference', x: 1822, y: 598, w: 256.5, h: 176.5, inset: '10.29% 13.58% 0 5.52%', depth: 0.7 },
    { src: g20_1x, src2x: g20_2x, alt: 'Large conference audience facing stage with INBOUND branding and red/purple lighting', x: 2030, y: 367, w: 458, h: 450, inset: '2.93% 2.77% 0.73% 1.05%', depth: 0.4 },
    { src: g21_1x, src2x: g21_2x, alt: 'Professional woman with short red hair and glasses smiling during conference panel', x: 2271.5, y: 100, w: 197.5, h: 428.5, inset: '13.66% 2.89% 6.57% 3.71%', depth: 0.6 },
    { src: g22_1x, src2x: g22_2x, alt: 'Woman with curly hair sitting at conference table, smiling and resting chin on hand', x: 2367, y: 557.5, w: 515, h: 256.5, inset: '1.93% 2.11% 0.3% 6.15%', depth: 0.3 },
    { src: g23_1x, src2x: g23_2x, alt: 'Two smiling men in matching green t-shirts and lanyards pose together at conference', x: 2463.5, y: -22, w: 419.5, h: 584, inset: '0 1.52% 3.29% 0.64%', depth: 0.5 },
    { src: g24_1x, src2x: g24_2x, alt: 'Woman speaking at conference, wearing polka dot top and light cardigan, gesturing', x: 2660, y: 366.5, w: 397, h: 262.5, inset: '2.98% 3.8% 1.05% 6.68%', depth: 0.7 },
    { src: g30_1x, src2x: g30_2x, alt: 'Audience members smiling and applauding at a conference presentation', x: 2748, y: -185, w: 380, h: 262.5, inset: '1.44% 7.34% 2.46% 2.08%', depth: 0.4 },
    { src: g26_1x, src2x: g26_2x, alt: 'Man in blue cardigan and glasses speaking while seated on white couch', x: 2851.5, y: 24.5, w: 475.5, h: 376.5, inset: '0.49% 1.83% 2.49% 1.84%', depth: 0.6 },
    { src: g31_1x, src2x: g31_2x, alt: 'Smiling woman with curly hair in dark patterned top at conference with other attendees', x: 2886.5, y: 543, w: 457, h: 319, inset: '0.63% 1.04% 1.05% 1.35%', depth: 0.3 },
    { src: g25_1x, src2x: g25_2x, alt: 'Conference attendees networking and socializing at standing tables in a crowded event space', x: 3013, y: 279, w: 466.5, h: 319, inset: '0.81% 2.21% 4.3% 8.13%', depth: 0.5 },
    { src: g33_1x, src2x: g33_2x, alt: 'Woman speaking at conference with laptop, gesturing while presenting', x: 3135, y: -153, w: 258.5, h: 217.5, inset: '4.4% 2.34% 3.26% 6.29%', depth: 0.7 },
    { src: g27_1x, src2x: g27_2x, alt: 'Smiling man in red shirt with conference badge networking with attendees', x: 3326.5, y: -29, w: 397.5, h: 351, inset: '0 0.89% 0.73% 2.16%', depth: 0.4 },
    { src: g32_1x, src2x: g32_2x, alt: 'Woman with long brown hair speaking at conference with pink and purple backdrop', x: 3355.5, y: 608, w: 381, h: 215, inset: '6.08% 1.49% 0 2.34%', depth: 0.6 },
    { src: g28_1x, src2x: g28_2x, alt: 'Speaker presenting at conference, gesturing with hand while speaking on stage', x: 3471, y: 357, w: 277, h: 309.5, inset: '1.73% 0 1.86% 3.06%', depth: 0.5 },
];

function photoStyle(photo, i) {
    const hovered = hoveredPhoto.value === i;
    const anyHovered = hoveredPhoto.value !== -1;
    const s = hovered ? 1.05 : anyHovered ? 0.97 : 1;
    return {
        left: photo.x + 'px',
        top: photo.y + 'px',
        width: photo.w + 'px',
        height: photo.h + 'px',
        transform: `scale(${s})`,
    };
}
</script>

<template>
    <section ref="sectionRef"
        aria-label="Photo gallery from previous INBOUND events"
        class="block-image-gallery relative w-full h-[80svh] md:h-[751px] overflow-hidden"
        style="background: linear-gradient(9.39deg, #FF9700 5.16%, #FF4800 20.66%, #820CA7 137.7%);"
        >

        <div ref="canvasRef"
            class="absolute left-1/2 top-1/2 select-none"
            style="touch-action: pan-y;"
            :style="canvasStyle"
            aria-hidden="true"
            @pointerdown="onPointerDown"
            @pointermove="onPointerMove"
            @pointerup="onPointerUp"
            @pointercancel="onPointerUp">

            <!-- Atmospheric blurred ellipses -->
            <div v-for="(el, i) in ellipses" :key="'e' + i"
                class="absolute"
                :style="{ left: el.x + 'px', top: el.y + 'px', width: el.w + 'px', height: el.h + 'px' }">
                <div class="absolute" :style="{ inset: el.expand }">
                    <img :src="el.src" loading="lazy" decoding="async" alt="" draggable="false" class="display-block max-w-none size-full" />
                </div>
            </div>

            <!-- Masked photos with parallax + pop-in -->
            <div v-for="(photo, i) in photos" :key="'p' + i"
                :class="['absolute transition-transform duration-700 ease-out', isVisible ? 'gallery-pop-in' : 'gallery-hidden']"
                :style="{ ...photoStyle(photo, i), animationDelay: (i * 60) + 'ms' }"
                @mouseenter="hoveredPhoto = i"
                @mouseleave="hoveredPhoto = -1">
                <div v-if="photo.inset" class="absolute" :style="{ inset: photo.inset }">
                    <img :src="photo.src" :srcset="`${photo.src} 1x, ${photo.src2x} 2x`" loading="lazy" decoding="async" :alt="photo.alt || ''" draggable="false" class="display-block max-w-none size-full" />
                </div>
                <img v-else :src="photo.src" :srcset="`${photo.src} 1x, ${photo.src2x} 2x`" loading="lazy" decoding="async" :alt="photo.alt || ''" draggable="false" class="absolute display-block max-w-none size-full" />
            </div>
        </div>
    </section>
</template>

<style>
.gallery-hidden {
    scale: 0;
    opacity: 0;
}

.gallery-pop-in {
    animation: gallery-bounce-in 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes gallery-bounce-in {
    from {
        scale: 0;
        opacity: 0;
    }
    to {
        scale: 1;
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .gallery-hidden {
        scale: 1;
        opacity: 1;
    }

    .gallery-pop-in {
        animation: none;
        scale: 1;
        opacity: 1;
    }
}
</style>
